module.exports = "<div class=\"row-align-middle\">\n  <div class=\"gr-7 gr-12@phablet\">\n    <p>A presskit including detailed information and high resolution images is now available for download.</a>\n    </p>\n  </div>\n  <div class=\"gr-5 gr-12@phablet flash-message__content__button-wrapper\">\n    <a class=\"button button--green button--rounded\" href=\"/static/downloads/e-Crown.zip\">\n          DOWNLOAD PRESSKIT\n        </a>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/flash-messages/presskit/index.html
// module id = 0+SN
// module chunks = 1